module.exports = __webpack_public_path__ + "media/bootstrap-icons/power-1ed7b00a.svg";